export interface QuotesMappingProps {
  detail?: any;
  quoteId: string;
  selectCD: string;
  isMapProduct?:boolean;
  reloadTable?: Function;
  sequenceNumber: string;
  isNoSegmented?: boolean;
  enableButtonApproveSuggestions?: boolean;
  distributionCenter?: any;
  segmentSelected?: string;
  onCloseAction: () => void;
}

export const typesMedicice = ['MEDICAMENTO', 'ONCO', 'ALTO CUSTO', 'VACINA', 'DEFAULT', ''];
export const typesMaterial = ['MATERIAL'];
export const typesNutrition = ['NUTRITION'];